// ----------------------------------------------------------------------

function path(root: string, subLink: string) {
  return `${root}${subLink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: path(ROOTS_AUTH, '/login'),
  forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
  setPassword: path(ROOTS_AUTH, '/set-password'),
  signUp: path(ROOTS_AUTH, '/sign-up'),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  onBoarding: path(ROOTS_DASHBOARD, '/on-boarding'),
  homeScreen: path(ROOTS_DASHBOARD, '/home-screen'),
  myMealsScreen: path(ROOTS_DASHBOARD, '/myMealsScreen'),
  findARecipeScreen: path(ROOTS_DASHBOARD, '/FindARecipeScreen'),
  favoritesScreen: path(ROOTS_DASHBOARD, '/FavoritesScreen'),
  viewAllScreen: path(ROOTS_DASHBOARD, '/viewAllScreen'),
  ingredientBasedRecipeScreen: path(ROOTS_DASHBOARD, '/ingredientBasedRecipeScreen'),
  recipeDetailsScreen: path(ROOTS_DASHBOARD, '/recipeDetailsScreen'),
  searchScreen: path(ROOTS_DASHBOARD, '/searchScreen'),

  dashboard: path(ROOTS_DASHBOARD, '/dashboard'),
  users: path(ROOTS_DASHBOARD, '/users'),
  permissions: path(ROOTS_DASHBOARD, '/permissions'),
  userDetail: path(ROOTS_DASHBOARD, '/users/userDetail'),
  players: path(ROOTS_DASHBOARD, '/players'),
  locations: path(ROOTS_DASHBOARD, '/locations'),
  locationDetail: path(ROOTS_DASHBOARD, '/locations/locationDetail'),
  challenges: path(ROOTS_DASHBOARD, '/challenges'),
  challengeDetail: path(ROOTS_DASHBOARD, '/challenges/challengeDetail'),
  playerDetail: path(ROOTS_DASHBOARD, '/players/details'),
  rewardsManagement: path(ROOTS_DASHBOARD, '/rewardsManagement'),
  wishboneManagement: path(ROOTS_DASHBOARD, '/wishboneManagement'),
  transaction: path(ROOTS_DASHBOARD, '/transaction'),
  notification: path(ROOTS_DASHBOARD, '/notification'),
  myProfile: path(ROOTS_DASHBOARD, '/myProfile'),
};
